import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource} from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';
import { DlgDomiciliosComponent } from '../../components/dlg-domicilios/dlg-domicilios.component';
import { funciones } from '../../funciones';
import { DlgMailsComponent } from '../../components/dlg-mails/dlg-mails.component';
import { DlgTelefonosComponent } from '../../components/dlg-telefonos/dlg-telefonos.component';
import { DlgWhatsAppComponent } from '../../components/dlg-whats-app/dlg-whats-app.component';
import { DlgObraSocialPacienteComponent } from '../../components/dlg-obra-social-paciente/dlg-obra-social-paciente.component';

@Component({
  selector: 'app-dlg-pacientes-mod',
  templateUrl: './dlg-pacientes-mod.component.html',
  styleUrls: ['./dlg-pacientes-mod.component.css']
})
export class DlgPacientesModComponent implements OnInit {

  titulo="";
  idActual="";
  apellido="";
  nombre="";
  txtFecNac="";
  txtTipoDoc="";
  txtNumDoc="";
  txtTipoSexo="";
  txtObservaciones="";

  idTipoDoc="";
  tipoDocNombre="";
  idTipoSexo="";
  tipoSexoNombre="";

  escondeFraseNoHayDomicilios=false;
  displayedColumnsDomicilios: string[] = ['acciones','fecha','nombreTipoDomicilio','domMostrar'];
  domicilios: any[] = [];
  dataSourceDomicilios = new MatTableDataSource();
  @ViewChild('paginadorDomicilios') paginadorDomicilios: MatPaginator;

  escondeFraseNoHayMails=false;
  displayedColumnsMails: string[] = ['acciones','fecha','nombreTipoMail','mail'];
  mails: any[] = [];
  dataSourceMails = new MatTableDataSource();
  @ViewChild('paginadorMails') paginadorMails: MatPaginator;
  
  escondeFraseNoHayTelefono=false;
  displayedColumnsTelefonos: string[] = ['acciones','fecha','nombreTipoTelefono','telefono'];
  telefonos: any[] = [];
  dataSourceTelefonos = new MatTableDataSource();
  @ViewChild('paginadorTelefonos') paginadorTelefonos: MatPaginator;

  escondeFraseNoHayWhatsAPP=false;
  displayedColumnsWhatsAPP: string[] = ['acciones','fecha','whatsAPP'];
  whatsAPP: any[] = [];
  dataSourceWhatsAPP = new MatTableDataSource();
  @ViewChild('paginadorWhatsAPP') paginadorWhatsAPP: MatPaginator;

  escondeFraseNoHayObraSocial=false;
  displayedColumnsOBRASOCIAL: string[] = ['acciones','fecha','frase'];
  obraSocial: any[] = [];
  dataSourceObraSocial = new MatTableDataSource();
  @ViewChild('paginadorOBRASOCIAL') paginadorOBRASOCIAL: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgPacientesModComponent>,
  ) { }

  ngOnInit(): void {
    if (this.storage.get("idConexion")==null){
      this.router.navigate(['/'])
    }
    this.leerDato();
  }

  leerDato(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose:true
    });
    dlgTrabajando.componentInstance.titulo="";
    dlgTrabajando.componentInstance.texto="Buscando los datos del paciente";

    this.httpClient.get(environment.servidorHttp+'Sistema/leerPacienteDato'
      ,{
        params: {
          "idConexion": this.storage.get("idConexion"),
          "idPaciente": this.idActual,
        },
        headers:{
          "Authorization":'Bearer ' + this.storage.get("token"),
        }
      })
    .subscribe(data => {
      this.cerrarDialogo(dlgTrabajando);
      if (data['resultado']['msgError']['valorDevuelto']=="01"){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al buscar los datos del paciente";
        dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
      } else{
        this.titulo=data['resultado']['msgError']['titulo'];
        if (data['resultado']['msgError']['nombre']!=null){
          //this.nombre=data['resultado']['msgError']['nombre'];
          //this.habilitado=data['resultado']['msgError']['habilitado']=="1";
        }
        if (data['resultado']['domicilios']!=undefined){
          this.domicilios=data['resultado']['domicilios'];
          this.mustrarDomicilios();
        }
      }
    },
    (error: HttpErrorResponse) => {
      this.cerrarDialogo(dlgTrabajando);
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      if (error.status.toString()=="401"){
        dlgError.componentInstance.titulo="Error al buscar los datos del paciente";
        dlgError.componentInstance.texto="Su sesión ha finalizado";
        this.router.navigate(['/']);
      }else{
        dlgError.componentInstance.titulo="Error al buscar los datos del paciente";
        dlgError.componentInstance.texto=error.message+" ("+error.status+")";
      }
    });
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena});
  }

  //#region tipo de documento
  buscarTipoDoc(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Tipos de documento:";
    dlgBusquedas.componentInstance.codBusqueda="TIPDOC";
    dlgBusquedas.componentInstance.txtBusc=this.txtTipoDoc;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idTipoDoc!=null){
          this.idTipoDoc=data.idTipoDoc;
          this.tipoDocNombre=data.nombre;
        }
      }
    );
  }

  eliminarTipoDoc(){
    this.idTipoDoc="";
    this.tipoDocNombre="";
  }
  //#endregion

  //#region tipo de sexo
  buscarTipoSexo(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Tipos de sexo:";
    dlgBusquedas.componentInstance.codBusqueda="TIPSEXO";
    dlgBusquedas.componentInstance.txtBusc=this.txtTipoSexo;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idTipoSexo!=null){
          this.idTipoSexo=data.idTipoSexo;
          this.tipoSexoNombre=data.nombre;
        }
      }
    );
  }

  eliminarTipoSexo(){
    this.idTipoSexo="";
    this.tipoSexoNombre="";
  }
  //#endregion

  //#region domicilio
  public buscarDomicilio = (value: string) => {
    this.dataSourceDomicilios.filter = value.trim().toLocaleLowerCase();
  }

  mustrarDomicilios(){
    if (this.domicilios == undefined) {
      this.escondeFraseNoHayDomicilios = false;
      return;
    }
    else {
      this.escondeFraseNoHayDomicilios = true;
      this.dataSourceDomicilios = new MatTableDataSource<any>(this.domicilios);
      this.dataSourceDomicilios.paginator = this.paginadorDomicilios;
      this.paginadorDomicilios._intl.itemsPerPageLabel = 'Domicilios por hoja';
      this.paginadorDomicilios._intl.nextPageLabel  = 'Proxima hoja';
      this.paginadorDomicilios._intl.previousPageLabel  = 'Hoja anterior';
      this.paginadorDomicilios._intl.lastPageLabel  = 'Última hoja';
      this.paginadorDomicilios._intl.firstPageLabel  = 'Primera hoja';
      this.paginadorDomicilios._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
      }
    }
  }

  modificarDomicilio(idDomicilio, idTipoDomicilio, nombreTipoDomicilio, calle, num
    , piso, depto, idProvincia, nombreProvincia, idLocalidad, nombreLocalidad){
    var tituloVentana="Modificar domicilio";
    if (idDomicilio=='00000000-0000-0000-0000-000000000000'){
      tituloVentana="Agregar domicilio"
    }
    let dlgModificarDomicilio = this.dialog.open(DlgDomiciliosComponent, {
      maxWidth: '90vw',
      maxHeight: '90vh',
      height: '100%',
      width: '100%',
      disableClose:true
    });
    dlgModificarDomicilio.componentInstance.titulo=tituloVentana;
    dlgModificarDomicilio.componentInstance.idDomicilio=idDomicilio;
    dlgModificarDomicilio.componentInstance.idTipoDomicilio=idTipoDomicilio;
    dlgModificarDomicilio.componentInstance.nombreTipoDomicilio=nombreTipoDomicilio;
    dlgModificarDomicilio.componentInstance.txtDomicilioCalle=calle;
    dlgModificarDomicilio.componentInstance.txtDomicilioNum=num;
    dlgModificarDomicilio.componentInstance.txtDomicilioPiso=piso;
    dlgModificarDomicilio.componentInstance.txtDomicilioDepto=depto;
    dlgModificarDomicilio.componentInstance.idProvincia=idProvincia;
    dlgModificarDomicilio.componentInstance.nombreProvincia=nombreProvincia;
    dlgModificarDomicilio.componentInstance.idLocalidad=idLocalidad;
    dlgModificarDomicilio.componentInstance.nombreLocalidad=nombreLocalidad;
    dlgModificarDomicilio.afterClosed().subscribe(
      data => {
        if (data.mensaje=="almaceno"){
          if (data.idDomicilio=="00000000-0000-0000-0000-000000000000"){
            data.idDomicilio=funciones.newGuid();
          }
          var domicilio=data.txtDomicilioCalle;
          if (data.txtDomicilioNum!=""){
            domicilio=domicilio+", Nº:"+data.txtDomicilioNum
          }
          if (data.txtDomicilioPiso!=""){
            domicilio=domicilio+", Piso: "+data.txtDomicilioPiso
          }
          if (data.txtDomicilioDepto!=""){
            domicilio=domicilio+", Depto: "+data.txtDomicilioDepto
          }

          domicilio=domicilio+' ['+data.nombreLocalidad+' - '+data.nombreProvincia+']'

          this.domicilios.unshift({'fecha': "Ahora"
            , 'idDomicilio': data.idDomicilio
            , 'idTipoDomicilio': data.idTipoDomicilio
            , 'nombreTipoDomicilio': data.nombreTipoDomicilio
            , 'calle': data.txtDomicilioCalle
            , 'num': data.txtDomicilioNum
            , 'piso': data.txtDomicilioPiso
            , 'depto': data.txtDomicilioDepto
            , 'idProvincia': data.idProvincia
            , 'nombreProvincia': data.nombreProvincia
            , 'idLocalidad': data.idLocalidad
            , 'nombreLocalidad': data.nombreLocalidad
            , 'domMostrar': domicilio
          });

          this.mustrarDomicilios();
        }
      }
    );
  }

  //#endregion

  //#region mails
  public buscarMail = (value: string) => {
    this.dataSourceMails.filter = value.trim().toLocaleLowerCase();
  }

  mostrarMails(){
    if (this.mails == undefined) {
      this.escondeFraseNoHayMails = false;
      return;
    }
    else {
      this.escondeFraseNoHayMails = true;
      this.dataSourceMails = new MatTableDataSource<any>(this.mails);
      this.dataSourceMails.paginator = this.paginadorMails;
      this.paginadorMails._intl.itemsPerPageLabel = 'Mails por hoja';
      this.paginadorMails._intl.nextPageLabel  = 'Proxima hoja';
      this.paginadorMails._intl.previousPageLabel  = 'Hoja anterior';
      this.paginadorMails._intl.lastPageLabel  = 'Última hoja';
      this.paginadorMails._intl.firstPageLabel  = 'Primera hoja';
      this.paginadorMails._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
      }
    }
  }

  modificarMail(idMail, idTipoMail, nombreTipoMail, mail){
    var tituloVentana="Modificar mail";
    if (idMail=='00000000-0000-0000-0000-000000000000'){
      tituloVentana="Agregar mail"
    }
    let dlgModificarMail = this.dialog.open(DlgMailsComponent, {
      maxWidth: '60vw',
      maxHeight: '50vh',
      height: '100%',
      width: '100%',
      disableClose:true
    });
    dlgModificarMail.componentInstance.titulo=tituloVentana;
    dlgModificarMail.componentInstance.idMail=idMail;
    dlgModificarMail.componentInstance.idTipoMail=idTipoMail;
    dlgModificarMail.componentInstance.nombreTipoMail=nombreTipoMail;
    dlgModificarMail.componentInstance.txtMail=mail;
    dlgModificarMail.afterClosed().subscribe(
      data => {
        if (data.mensaje=="almaceno"){
          if (data.idMail=="00000000-0000-0000-0000-000000000000"){
            data.idMail=funciones.newGuid();
          }
          
          funciones.eliminarValorDeArray(this.mails, "idMail", idMail)

          this.mails.unshift({'fecha': "Ahora"
            , 'idMail': data.idMail
            , 'idTipoMail': data.idTipoMail
            , 'nombreTipoMail': data.nombreTipoMail
            , 'mail': data.txtMail
          });

          this.mostrarMails();
        }
      }
    );
  }
  //#endregion
  
  //#region telefonos
  public buscarTelefono = (value: string) => {
    this.dataSourceTelefonos.filter = value.trim().toLocaleLowerCase();
  }

  mostrarTelefonos(){
    if (this.telefonos == undefined) {
      this.escondeFraseNoHayTelefono = false;
      return;
    }
    else {
      this.escondeFraseNoHayTelefono = true;
      this.dataSourceTelefonos = new MatTableDataSource<any>(this.telefonos);
      this.dataSourceTelefonos.paginator = this.paginadorTelefonos;
      this.paginadorTelefonos._intl.itemsPerPageLabel = 'Telefonos por hoja';
      this.paginadorTelefonos._intl.nextPageLabel  = 'Proxima hoja';
      this.paginadorTelefonos._intl.previousPageLabel  = 'Hoja anterior';
      this.paginadorTelefonos._intl.lastPageLabel  = 'Última hoja';
      this.paginadorTelefonos._intl.firstPageLabel  = 'Primera hoja';
      this.paginadorTelefonos._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
      }
    }
  }

  modificarTelefono(idTelefono, idTipoTelefono, nombreTipoTelefono, telefono){
    var tituloVentana="Modificar telefono";
    if (idTelefono=='00000000-0000-0000-0000-000000000000'){
      tituloVentana="Agregar teléfono"
    }
    let dlgModificarTelefono = this.dialog.open(DlgTelefonosComponent, {
      maxWidth: '60vw',
      maxHeight: '50vh',
      height: '100%',
      width: '100%',
      disableClose:true
    });
    dlgModificarTelefono.componentInstance.titulo=tituloVentana;
    dlgModificarTelefono.componentInstance.idTelefono=idTelefono;
    dlgModificarTelefono.componentInstance.idTipoTelefono=idTipoTelefono;
    dlgModificarTelefono.componentInstance.nombreTipoTelefono=nombreTipoTelefono;
    dlgModificarTelefono.componentInstance.txtTelefono=telefono;
    dlgModificarTelefono.afterClosed().subscribe(
      data => {
        if (data.mensaje=="almaceno"){
          if (data.idTelefono=="00000000-0000-0000-0000-000000000000"){
            data.idTelefono=funciones.newGuid();
          }
          
          funciones.eliminarValorDeArray(this.telefonos, "idTelefono", idTelefono)

          this.telefonos.unshift({'fecha': "Ahora"
            , 'idTelefono': data.idTelefono
            , 'idTipoTelefono': data.idTipoTelefono
            , 'nombreTipoTelefono': data.nombreTipoTelefono
            , 'telefono': data.txtTelefono
          });

          this.mostrarTelefonos();
        }
      }
    );
  }
  //#endregion

  //#region WhatsAPP
  public buscarWhatsAPP = (value: string) => {
    this.dataSourceWhatsAPP.filter = value.trim().toLocaleLowerCase();
  }

  mostrarWhatsAPP(){
    if (this.whatsAPP == undefined) {
      this.escondeFraseNoHayWhatsAPP = false;
      return;
    }
    else {
      this.escondeFraseNoHayWhatsAPP = true;
      this.dataSourceWhatsAPP = new MatTableDataSource<any>(this.whatsAPP);
      this.dataSourceWhatsAPP.paginator = this.paginadorWhatsAPP;
      this.paginadorWhatsAPP._intl.itemsPerPageLabel = 'WhatsAPP por hoja';
      this.paginadorWhatsAPP._intl.nextPageLabel  = 'Proxima hoja';
      this.paginadorWhatsAPP._intl.previousPageLabel  = 'Hoja anterior';
      this.paginadorWhatsAPP._intl.lastPageLabel  = 'Última hoja';
      this.paginadorWhatsAPP._intl.firstPageLabel  = 'Primera hoja';
      this.paginadorWhatsAPP._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
      }
    }
  }

  modificarWhatsAPP(idWhatsAPP, whatsAPP){
    var tituloVentana="Modificar WhatsAPP";
    if (idWhatsAPP=='00000000-0000-0000-0000-000000000000'){
      tituloVentana="Agregar WhatsAPP"
    }
    let dlgModificarWhastAPP = this.dialog.open(DlgWhatsAppComponent, {
      maxWidth: '60vw',
      maxHeight: '50vh',
      height: '100%',
      width: '100%',
      disableClose:true
    });
    dlgModificarWhastAPP.componentInstance.titulo=tituloVentana;
    dlgModificarWhastAPP.componentInstance.idWhatsAPP=idWhatsAPP;
    dlgModificarWhastAPP.componentInstance.txtWhatsAPP=whatsAPP;
    dlgModificarWhastAPP.afterClosed().subscribe(
      data => {
        if (data.mensaje=="almaceno"){
          if (data.idWhatsAPP=="00000000-0000-0000-0000-000000000000"){
            data.idWhatsAPP=funciones.newGuid();
          }
          
          funciones.eliminarValorDeArray(this.whatsAPP, "idWhatsAPP", idWhatsAPP)

          this.whatsAPP.unshift({'fecha': "Ahora"
            , 'idWhatsAPP': data.idWhatsAPP
            , 'whatsAPP': data.txtWhatsAPP
          });

          this.mostrarWhatsAPP();
        }
      }
    );
  }
  //#endregion

  //#region obras sociales
  public buscarObraSocial = (value: string) => {
    this.dataSourceObraSocial.filter = value.trim().toLocaleLowerCase();
  }

  mostrarObraSocial(){
    if (this.obraSocial == undefined) {
      this.escondeFraseNoHayObraSocial = false;
      return;
    }
    else {
      this.escondeFraseNoHayObraSocial = true;
      this.dataSourceObraSocial = new MatTableDataSource<any>(this.obraSocial);
      this.dataSourceObraSocial.paginator = this.paginadorOBRASOCIAL;
      this.paginadorOBRASOCIAL._intl.itemsPerPageLabel = 'Obras sociales por hoja';
      this.paginadorOBRASOCIAL._intl.nextPageLabel  = 'Proxima hoja';
      this.paginadorOBRASOCIAL._intl.previousPageLabel  = 'Hoja anterior';
      this.paginadorOBRASOCIAL._intl.lastPageLabel  = 'Última hoja';
      this.paginadorOBRASOCIAL._intl.firstPageLabel  = 'Primera hoja';
      this.paginadorOBRASOCIAL._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
      }
    }
  }

  modificarObraSocial(idObraSocialPaciente, idObraSocial, nombreObraSocial, idPlan
    , nombrePlan, numAfiliado, tipoGravado){
    var tituloVentana="Modificar Obra social";
    if (idObraSocialPaciente=='00000000-0000-0000-0000-000000000000'){
      tituloVentana="Agregar Obra Social"
    }
    let dlgModificarOS = this.dialog.open(DlgObraSocialPacienteComponent, {
      maxWidth: '90vw',
      maxHeight: '80vh',
      height: '100%',
      width: '100%',
      disableClose:true
    });
    var noTienePlanes=true, noGravado=true;
    if (idPlan!=""){
      noTienePlanes=false;
    }
    if (tipoGravado!=""){
      noGravado=false;
    }
    dlgModificarOS.componentInstance.titulo=tituloVentana;
    dlgModificarOS.componentInstance.idActual=idObraSocialPaciente;
    dlgModificarOS.componentInstance.idObraSocial=idObraSocial;
    dlgModificarOS.componentInstance.nombreObraSocial=nombreObraSocial;
    dlgModificarOS.componentInstance.noTienePlanes=noTienePlanes;
    dlgModificarOS.componentInstance.idPlanObraSocial=idPlan;
    dlgModificarOS.componentInstance.nombrePlanObraSocial=nombrePlan;
    dlgModificarOS.componentInstance.txtNumAfiliado=numAfiliado;
    dlgModificarOS.componentInstance.noGravado=noGravado;
    dlgModificarOS.componentInstance.tipoGravado=tipoGravado;
    dlgModificarOS.afterClosed().subscribe(
      data => {
        if (data.mensaje=="almaceno"){
          if (data.idObraSocialPaciente=="00000000-0000-0000-0000-000000000000"){
            data.idObraSocialPaciente=funciones.newGuid();
          }
          
          var frase=data.nombreOS;
          if (data.nombrePlan!=""){
            frase=frase+" ("+data.nombrePlan+")"
          }
          frase=frase+", Nº:"+data.numAfiliado;
          if (data.tipoGravado!=""){
            frase=frase+", Gravado: ";
            if (data.tipoGravado=="GRAVADO"){
              frase=frase+"SI";
            }else{
              frase=frase+"NO";
            }
          }

          funciones.eliminarValorDeArray(this.obraSocial, "idObraSocialPaciente", idObraSocialPaciente)

          this.obraSocial.unshift({'fecha': "Ahora"
            , 'idObraSocialPaciente': data.idObraSocialPaciente
            , 'idObraSocial': data.idObraSocial
            , 'nombreObraSocial': data.nombreOS
            , 'idPlan': data.idPlan
            , 'nombrePlan': data.nombrePlan
            , 'numAfiliado': data.numAfiliado
            , 'tipoGravado': data.tipoGravado
            , "frase":frase
          });

          this.mostrarObraSocial();
        }
      }
    );
  }
  //#endregion

  almacenar(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose: true
    });
    dlgTrabajando.componentInstance.titulo = "";
    dlgTrabajando.componentInstance.texto = "Intentando almacenar el paciente";

    var formData: any = new FormData();
    formData.append('idConexion', this.storage.get("idConexion"));
    formData.append('idPaciente', this.idActual);
    formData.append('apellido', this.apellido);
    formData.append('nombre', this.nombre);
    formData.append('fecNac', this.txtFecNac);
    formData.append('idTipDoc', this.idTipoDoc);
    formData.append('numDoc', this.txtNumDoc);
    formData.append('idTipoSexo', this.idTipoSexo);
    formData.append('observaciones', this.txtObservaciones);
    formData.append('dtDomicilios', JSON.stringify(this.domicilios));
    formData.append('dtMails', JSON.stringify(this.mails));
    formData.append('dtTelefonos', JSON.stringify(this.telefonos));
    formData.append('dtWhatsAPP', JSON.stringify(this.whatsAPP));
    formData.append('dtObrasSociales', JSON.stringify(this.obraSocial));
    
    this.httpClient.post(environment.servidorHttp + 'Sistema/modificarPaciente', formData,
    {
      headers: {
        "Authorization": "Bearer " + this.storage.get("token") 
      },
    })
    .subscribe(data => {
      this.cerrarDialogo(dlgTrabajando);
      if (data['resultado']['msgError']['valorDevuelto'] == "01") {
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose: true
        });
        dlgError.componentInstance.titulo = "Error al almacenar el paciente";
        dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
      } else if (data['resultado']['msgError']['valorDevuelto'] == "10") {
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose: true
        });
        dlgError.componentInstance.titulo = "Error al almacenar el paciente";
        dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        this.router.navigate(['/']);
      } else {
        let dlgAviso = this.dialog.open(DlgAvisoComponent, {
          width: '600px',
          disableClose: true
        });
        dlgAviso.componentInstance.titulo = "Aviso del sistema";
        dlgAviso.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        this.cerrar('almaceno');
      }
    },
      (error: HttpErrorResponse) => {
        this.cerrarDialogo(dlgTrabajando);
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose: true
        });
        if (error.status.toString() == "401") {
          dlgError.componentInstance.titulo = "Error al almacenar el paciente";
          dlgError.componentInstance.texto = "Su sesión ha finalizado";
          this.router.navigate(['/']);
        } else {
          dlgError.componentInstance.titulo = "Error al almacenar el paciente";
          dlgError.componentInstance.texto = error.message + " (" + error.status + ")";
        }
      }
    );
  }
}
